import { createContext, useContext, useState } from "react";

const SidebarContext = createContext();

export const SidebarProvider = ({ children }) => {
  const [openKeys, setOpenKeys] = useState([]);

  return (
    <SidebarContext.Provider value={{ openKeys, setOpenKeys }}>
      {children}
    </SidebarContext.Provider>
  );
};

export const useSidebar = () => useContext(SidebarContext);
